import { PRINT_CLOUD_STATUS_OPEN } from "@/constants"

class PrintCloud {

  /** @type {String} */ 
  uuid

  /** @type {Integer} */
  status = PRINT_CLOUD_STATUS_OPEN

  constructor (data) {
    this.uuid = data.uuid
    this.status = data.status
  }
}

export default PrintCloud